import { composeLabelValueDescriptor as e } from "../../../helpers/label-value/composeLabelValueDescriptor.js";
import { toArray as i } from "../../../helpers/formatting/toArray.js";
const f = ({
  label: r,
  selectedOptionsText: o,
  value: t
}) => i(t).length && typeof r == "string" ? `${r}: ${e(t, o)}` : r;
export {
  f as FilterLabel
};
